// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, role }) {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role");

  console.log(token,userRole);
  

  if (!token) {
    return <Navigate to="/login" />;
  }

  // ✅ If route needs specific role (like admin)
  if (role && userRole !== role) {
    console.log('admin');
    return <Navigate to="/dashboard" />;
  }

  return children;
}
